/**
 * @type {{
 *  defaultLocale: import("~types/types").AppLocale,
 *  locales: import("~types/types").AppLocale[]
 * }}
 */
const localeConfig = {
  defaultLocale: "nl",
  locales: ["en", "nl", "de", "es", "pt", "fr", "it"],
};

// export as commonjs so it's usable in node
module.exports = localeConfig;
